export const BarMenuTranslationJP = {
  BarMenuTranslationFeature: {
    Text: {
      title: '対象メニュー一覧',
      bar_guidance: 'ご案内：',
    },
    Button: {
      delete: '削除',
      add: '追加',
    },
    Table: {
      select: '選択',
      menu_code: 'メニューコード',
      menu_name: 'メニュー名',
    },
    DialogConfirm: {
      btn_cancel: 'キャンセル',
      btn_save: 'OK',
      title: '確認',
      message_delete: '選択されたメニューを削除します。<br/>よろしいですか？',
    },
    Toast: {
      success: '成功',
      error: 'エラー',
    },
  },
};
